<template>
	<div class="results-none content-section text-center pt-2">
		<div v-show="!isMobileMapView" class="result-card py-6 px-4 rounded-4">
			<OverlappingCirclesIcon class="my-1" />
			<h2 class="display-5 my-2">No results found</h2>
			<p class="small">
				There aren't any locations that match your search criteria. Try another city,<span
					class="d-none d-lg-inline"
				>
					zoom out,</span
				>
				or
				<a :href="viewAllClubsUrl">view a list of all locations</a>.
			</p>
		</div>
		<div v-show="isMobileMapView" class="result-card flex-column text-start rounded-4">
			<OverlappingCirclesIcon class="my-1" />
			<h2 class="h2 mb-0 mb-lg-2">No results found</h2>
			<p class="small mb-0 d-block d-lg-none">
				Zoom out or
				<a :href="viewAllClubsUrl">view a list of all locations</a>.
			</p>
			<p class="small mb-0 d-none d-lg-block">
				There aren't any locations that match your search criteria. Try another city, or
				<a :href="viewAllClubsUrl">view a list of all locations</a>.
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import OverlappingCirclesIcon from '@/lib/icons/OverlappingCirclesIcon.vue';
import { getGlobalPageDriverUrl } from '@/util/globalPageDriver';

defineProps<{
	isMobileMapView: boolean;
}>();

const viewAllClubsUrl = getGlobalPageDriverUrl('viewAllClubs');
</script>

<style scoped lang="scss">
body:not(.find-location-mapview) .result-card {
	background-color: $contrast-200;
	cursor: default;
}

// Targets only the card on the mobile map view
.find-location-mapview .result-card {
	display: flex;
	padding: 1.5rem 1rem !important; // needed because of !important used on .result-card in _find-a-location.scss
	position: fixed;
	bottom: 5.875rem;
	z-index: 2;
	left: 1rem;
	right: 1rem;
	cursor: default;

	@include media-breakpoint-up(lg) {
		background-color: $contrast-200;
		position: static;
		align-items: center;
		padding-top: 3rem !important;
		padding-bottom: 3rem !important;
	}

	:deep(.overlapping-circles-icon) {
		@include media-breakpoint-down(lg) {
			width: 50px;
			height: auto;
		}
	}
}
</style>
